/**
 * Funkcinės Terapijos Centras — Masažo tipo parinkimas
 * Self-injecting widget. Embed with:
 *
 *   Place <div id="ftc-massage-checker"></div> in your blog post HTML.
 *   Load via Liquid: {{ 'ftc-massage.js' | asset_url | script_tag }}
 */
(function () {
  'use strict';

  var scriptTag = document.currentScript;
  var KLAVIYO_COMPANY_ID = scriptTag.getAttribute('data-klaviyo-id') || 'WGyTS6';
  var KLAVIYO_LIST_ID = scriptTag.getAttribute('data-list-id') || 'TFtRBZ';
  var BOOKING_URL = scriptTag.getAttribute('data-booking-url') || 'https://funkcinesterapijoscentras.lt/pages/registracija';

  // ── Inject CSS ──
  var css = document.createElement('style');
  css.textContent = '' +
    '.ftcm *,.ftcm *::before,.ftcm *::after{box-sizing:border-box;margin:0;padding:0}' +
    '.ftcm{font-family:"Segoe UI",system-ui,-apple-system,sans-serif;max-width:640px;margin:40px auto;border-radius:16px;overflow:hidden;box-shadow:0 8px 32px rgba(30,126,186,.18);background:#fff}' +
    '.ftcm-header{background:linear-gradient(135deg,#1E7EBA 0%,#1a6da3 100%);padding:32px 28px 24px;text-align:center;position:relative;overflow:hidden}' +
    '.ftcm-header::before{content:"";position:absolute;top:-40%;right:-20%;width:260px;height:260px;background:rgba(0,190,195,.12);border-radius:50%}' +
    '.ftcm-header::after{content:"";position:absolute;bottom:-30%;left:-10%;width:180px;height:180px;background:rgba(255,255,255,.06);border-radius:50%}' +
    '.ftcm-header h2{color:#fff;font-size:22px;font-weight:700;margin-bottom:6px;position:relative;z-index:1;line-height:1.3}' +
    '.ftcm-header p{color:rgba(255,255,255,.85);font-size:14px;position:relative;z-index:1}' +
    '.ftcm-badge{display:inline-block;background:rgba(0,190,195,.25);color:#fff;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:1.2px;padding:4px 14px;border-radius:20px;margin-bottom:12px;position:relative;z-index:1}' +
    '.ftcm-progress-wrap{padding:0 28px;margin-top:-8px;position:relative;z-index:2}' +
    '.ftcm-progress-bar{height:6px;background:#e8f0f5;border-radius:3px;overflow:hidden;margin-top:16px}' +
    '.ftcm-progress-fill{height:100%;background:linear-gradient(90deg,#00BEC3,#1E7EBA);border-radius:3px;transition:width .5s cubic-bezier(.4,0,.2,1);width:0%}' +
    '.ftcm-step-count{text-align:center;font-size:12px;color:#7a9bb5;margin-top:8px;font-weight:500}' +
    '.ftcm-body{padding:24px 28px 28px;min-height:320px;position:relative}' +
    '.ftcm-intro{text-align:center}' +
    '.ftcm-intro-icon{width:72px;height:72px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 20px}' +
    '.ftcm-intro-icon svg{width:36px;height:36px;color:#1E7EBA}' +
    '.ftcm-intro h3{font-size:18px;color:#1a2e3d;margin-bottom:10px;font-weight:600}' +
    '.ftcm-intro p{font-size:14px;color:#5a7080;line-height:1.6;margin-bottom:8px}' +
    '.ftcm-intro-list{text-align:left;margin:16px auto;max-width:380px}' +
    '.ftcm-intro-list-item{display:flex;align-items:flex-start;gap:10px;padding:8px 0;font-size:13px;color:#3d5a6e}' +
    '.ftcm-intro-list-item .ftcm-check{width:20px;height:20px;min-width:20px;background:#00BEC3;border-radius:50%;display:flex;align-items:center;justify-content:center;margin-top:1px}' +
    '.ftcm-intro-list-item .ftcm-check svg{width:12px;height:12px;color:#fff}' +
    '.ftcm-slide{display:none;animation:ftcmFadeIn .4s ease}' +
    '.ftcm-slide.active{display:block}' +
    '@keyframes ftcmFadeIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}' +
    '.ftcm-question-num{font-size:12px;font-weight:600;color:#00BEC3;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px}' +
    '.ftcm-question-text{font-size:17px;color:#1a2e3d;font-weight:600;margin-bottom:6px;line-height:1.4}' +
    '.ftcm-question-hint{font-size:13px;color:#7a9bb5;margin-bottom:24px;line-height:1.5}' +
    '.ftcm-options{display:flex;flex-direction:column;gap:10px;margin-top:4px}' +
    '.ftcm-option{display:flex;align-items:center;gap:12px;padding:14px 16px;border:2px solid #e8f0f5;border-radius:12px;cursor:pointer;transition:all .25s ease;background:#fff}' +
    '.ftcm-option:hover{border-color:#b8dce8;background:#f6fbfd}' +
    '.ftcm-option.selected{border-color:#00BEC3;background:#e6f9fa}' +
    '.ftcm-option-radio{width:22px;height:22px;min-width:22px;border-radius:50%;border:2px solid #c8d8e2;display:flex;align-items:center;justify-content:center;transition:all .25s ease}' +
    '.ftcm-option.selected .ftcm-option-radio{border-color:#00BEC3;background:#00BEC3}' +
    '.ftcm-option.selected .ftcm-option-radio::after{content:"";width:8px;height:8px;background:#fff;border-radius:50%}' +
    '.ftcm-option-text{font-size:14px;color:#2a4050;font-weight:500}' +
    '.ftcm-slider-wrap{padding:12px 0 8px}' +
    '.ftcm-slider-labels{display:flex;justify-content:space-between;margin-bottom:12px}' +
    '.ftcm-slider-label{font-size:12px;font-weight:500;padding:6px 12px;border-radius:8px;transition:all .3s ease;max-width:45%;text-align:center;line-height:1.3}' +
    '.ftcm-slider-label.left{color:#27ae60;background:#e8f8ef}' +
    '.ftcm-slider-label.right{color:#c0392b;background:#fce8e6}' +
    '.ftcm-range-track{position:relative;height:48px;display:flex;align-items:center}' +
    '.ftcm-range{-webkit-appearance:none;appearance:none;width:100%;height:8px;border-radius:4px;background:linear-gradient(90deg,#27ae60,#e0e8ed 50%,#e05555);outline:none;cursor:pointer}' +
    '.ftcm-range::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:28px;height:28px;border-radius:50%;background:#fff;border:3px solid #00BEC3;box-shadow:0 2px 8px rgba(0,190,195,.3);cursor:pointer;transition:transform .2s ease,box-shadow .2s ease}' +
    '.ftcm-range::-webkit-slider-thumb:hover{transform:scale(1.15);box-shadow:0 3px 14px rgba(0,190,195,.4)}' +
    '.ftcm-range::-moz-range-thumb{width:28px;height:28px;border-radius:50%;background:#fff;border:3px solid #00BEC3;box-shadow:0 2px 8px rgba(0,190,195,.3);cursor:pointer}' +
    '.ftcm-range-value{text-align:center;margin-top:8px;font-size:13px;font-weight:600;color:#1E7EBA;min-height:20px}' +
    '.ftcm-buttons{display:flex;justify-content:space-between;align-items:center;margin-top:28px;gap:12px}' +
    '.ftcm-btn{padding:12px 28px;border-radius:10px;font-size:14px;font-weight:600;cursor:pointer;border:none;transition:all .3s ease;display:inline-flex;align-items:center;gap:6px}' +
    '.ftcm-btn-primary{background:linear-gradient(135deg,#00BEC3,#00a8ad);color:#fff;box-shadow:0 4px 14px rgba(0,190,195,.3)}' +
    '.ftcm-btn-primary:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,190,195,.4)}' +
    '.ftcm-btn-secondary{background:transparent;color:#7a9bb5;border:2px solid #e0e8ed}' +
    '.ftcm-btn-secondary:hover{border-color:#b8d0dd;color:#5a7a90}' +
    '.ftcm-btn-large{width:100%;justify-content:center;padding:14px 28px;font-size:15px}' +
    '.ftcm-btn svg{width:16px;height:16px}' +
    '.ftcm-email-gate{text-align:center}' +
    '.ftcm-email-gate h3{font-size:18px;color:#1a2e3d;margin-bottom:8px;font-weight:600}' +
    '.ftcm-email-gate p{font-size:14px;color:#5a7080;margin-bottom:20px;line-height:1.5}' +
    '.ftcm-email-icon{width:64px;height:64px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 16px}' +
    '.ftcm-email-icon svg{width:30px;height:30px;color:#1E7EBA}' +
    '.ftcm-input-wrap{position:relative;margin-bottom:12px}' +
    '.ftcm-input{width:100%;padding:14px 16px;border:2px solid #e0e8ed;border-radius:10px;font-size:14px;font-family:inherit;color:#2a4050;outline:none;transition:border-color .3s ease;background:#fff}' +
    '.ftcm-input:focus{border-color:#00BEC3}' +
    '.ftcm-input::placeholder{color:#a8bcc8}' +
    '.ftcm-email-note{font-size:11px;color:#a0b0bb;margin-top:8px}' +
    '.ftcm-email-error{color:#e05555;font-size:12px;margin-top:4px;display:none}' +
    '.ftcm-results{text-align:center}' +
    '.ftcm-result-circle-wrap{position:relative;width:160px;height:160px;margin:0 auto 20px}' +
    '.ftcm-result-circle{width:160px;height:160px;border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;z-index:1}' +
    '.ftcm-result-circle.therapeutic{background:linear-gradient(135deg,#e8f8ef,#d0f0db);border:3px solid #27ae60}' +
    '.ftcm-result-circle.deeptissue{background:linear-gradient(135deg,#e6f0fa,#cce0f5);border:3px solid #2c5282}' +
    '.ftcm-result-circle.rehab{background:linear-gradient(135deg,#fff4e6,#ffe8cc);border:3px solid #e8a04c}' +
    '.ftcm-result-circle.myofascial{background:linear-gradient(135deg,#f3e8fa,#e6d0f5);border:3px solid #8e44ad}' +
    '.ftcm-result-type{font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:1px;margin-bottom:2px}' +
    '.ftcm-result-label{font-size:16px;font-weight:700;text-align:center;line-height:1.2;padding:0 8px}' +
    '.ftcm-result-circle.therapeutic .ftcm-result-type{color:#1e8449}.ftcm-result-circle.therapeutic .ftcm-result-label{color:#1a7a40}' +
    '.ftcm-result-circle.deeptissue .ftcm-result-type{color:#2c5282}.ftcm-result-circle.deeptissue .ftcm-result-label{color:#1a365d}' +
    '.ftcm-result-circle.rehab .ftcm-result-type{color:#c46b20}.ftcm-result-circle.rehab .ftcm-result-label{color:#a35a18}' +
    '.ftcm-result-circle.myofascial .ftcm-result-type{color:#8e44ad}.ftcm-result-circle.myofascial .ftcm-result-label{color:#6c3483}' +
    '.ftcm-result-text{font-size:15px;color:#2a4050;line-height:1.6;margin-bottom:16px;max-width:480px;margin-left:auto;margin-right:auto}' +
    '.ftcm-result-detail{background:#f6f9fb;border-radius:12px;padding:16px 20px;margin-bottom:20px;text-align:left}' +
    '.ftcm-result-detail h4{font-size:14px;font-weight:600;color:#1a2e3d;margin-bottom:8px}' +
    '.ftcm-result-detail p{font-size:13px;color:#5a7080;line-height:1.5}' +
    '.ftcm-result-cta,.ftcm-result-cta:visited,.ftcm-result-cta:active,.ftcm-result-cta:hover{background:#00BEC3;color:#fff !important;padding:14px 32px;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;border:none;display:inline-flex;align-items:center;gap:8px;transition:all .3s ease;box-shadow:0 4px 14px rgba(0,190,195,.3);text-decoration:none !important}' +
    '.ftcm-result-cta:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,190,195,.4)}' +
    '.ftcm-result-cta svg{width:18px;height:18px}' +
    '.ftcm-disclaimer{font-size:11px;color:#a0b0bb;margin-top:16px;line-height:1.4;padding-top:12px;border-top:1px solid #eef2f5}' +
    '@media(max-width:480px){.ftcm{margin:16px 8px;border-radius:12px}.ftcm-header{padding:24px 20px 18px}.ftcm-header h2{font-size:19px}.ftcm-body{padding:20px 20px 24px}.ftcm-progress-wrap{padding:0 20px}.ftcm-slider-label{font-size:11px;padding:4px 8px}.ftcm-buttons{flex-direction:column-reverse}.ftcm-btn{width:100%;justify-content:center}}';
  document.head.appendChild(css);

  // ── SVG helpers ──
  var svgArrowRight = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6"/></svg>';
  var svgArrowLeft  = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M11 17l-5-5m0 0l5-5m-5 5h12"/></svg>';
  var svgCheck      = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4"/></svg>';
  var svgCheckSmall = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>';
  var svgMail       = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>';
  var svgCalendar   = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>';
  var svgHand       = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"/></svg>';

  // ── Build HTML ──
  var html = '' +
    '<div class="ftcm-header">' +
      '<div class="ftcm-badge">Nemokamas testas</div>' +
      '<h2>Koks masa\u017eas jums labiausiai tiktų?</h2>' +
      '<p>Masa\u017eo tipo parinkimo testas</p>' +
    '</div>' +
    '<div class="ftcm-progress-wrap" id="ftcmProgressWrap" style="display:none;">' +
      '<div class="ftcm-progress-bar"><div class="ftcm-progress-fill" id="ftcmProgressFill"></div></div>' +
      '<div class="ftcm-step-count" id="ftcmStepCount"></div>' +
    '</div>' +
    '<div class="ftcm-body">' +

      // Intro
      '<div class="ftcm-slide active" id="ftcmIntro"><div class="ftcm-intro">' +
        '<div class="ftcm-intro-icon">' + svgHand + '</div>' +
        '<h3>Raskite jums tinkamiausią masa\u017eo tipą</h3>' +
        '<p>Atsakykite į 5 klausimus ir su\u017einokite, koks masa\u017eo tipas geriausiai atitinka jūsų poreikius ir tikslus.</p>' +
        '<div class="ftcm-intro-list">' +
          '<div class="ftcm-intro-list-item"><div class="ftcm-check">' + svgCheckSmall + '</div><span>U\u017etrunka tik 2 minutes</span></div>' +
          '<div class="ftcm-intro-list-item"><div class="ftcm-check">' + svgCheckSmall + '</div><span>Pritaikytas jūsų poreikiams</span></div>' +
          '<div class="ftcm-intro-list-item"><div class="ftcm-check">' + svgCheckSmall + '</div><span>Gausite asmeninę rekomendaciją</span></div>' +
        '</div>' +
        '<button class="ftcm-btn ftcm-btn-primary ftcm-btn-large" id="ftcmStartBtn">Prad\u0117ti testą ' + svgArrowRight + '</button>' +
      '</div></div>' +

      // Q1 — Goal
      '<div class="ftcm-slide" id="ftcmQ1">' +
        '<div class="ftcm-question-num">1 klausimas i\u0161 5</div>' +
        '<div class="ftcm-question-text">Koks jūsų pagrindinis tikslas?</div>' +
        '<div class="ftcm-question-hint">Pasirinkite, ko labiausiai tik\u0117tis i\u0161 masa\u017eo.</div>' +
        '<div class="ftcm-options" id="ftcmO1">' +
          '<div class="ftcm-option" data-t="30" data-d="5" data-r="5" data-f="10"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Atsipalaidavimas ir streso ma\u017einimas</div></div>' +
          '<div class="ftcm-option" data-t="10" data-d="30" data-r="5" data-f="15"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Skausmo mal\u0161inimas</div></div>' +
          '<div class="ftcm-option" data-t="5" data-d="5" data-r="35" data-f="10"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Atsigavimas po traumos ar operacijos</div></div>' +
          '<div class="ftcm-option" data-t="5" data-d="10" data-r="5" data-f="30"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Pagerinti judrumą ir lankstumą</div></div>' +
        '</div>' +
      '</div>' +

      // Q2 — Pain type
      '<div class="ftcm-slide" id="ftcmQ2">' +
        '<div class="ftcm-question-num">2 klausimas i\u0161 5</div>' +
        '<div class="ftcm-question-text">Kokio pob\u016bd\u017eio diskomfortą jau\u010diate?</div>' +
        '<div class="ftcm-question-hint">Skausmo pob\u016bdis padeda parinkti tinkamą masa\u017eo techniką.</div>' +
        '<div class="ftcm-options" id="ftcmO2">' +
          '<div class="ftcm-option" data-t="5" data-d="35" data-r="5" data-f="10"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">L\u0117tin\u0117 gili raumenų įtampa ar \u201emazgai\u201c</div></div>' +
          '<div class="ftcm-option" data-t="10" data-d="15" data-r="25" data-f="5"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">A\u0161trus lokalizuotas skausmas</div></div>' +
          '<div class="ftcm-option" data-t="5" data-d="5" data-r="5" data-f="35"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Sustingimas, ribotas jud\u0117jimas</div></div>' +
          '<div class="ftcm-option" data-t="30" data-d="10" data-r="5" data-f="10"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Bendras diskomfortas, nuovargis, įtampa</div></div>' +
        '</div>' +
      '</div>' +

      // Q3 — Area
      '<div class="ftcm-slide" id="ftcmQ3">' +
        '<div class="ftcm-question-num">3 klausimas i\u0161 5</div>' +
        '<div class="ftcm-question-text">Kur jau\u010diate didžiausią diskomfortą?</div>' +
        '<div class="ftcm-question-hint">Masa\u017eo technika priklauso nuo paveiktos srities.</div>' +
        '<div class="ftcm-options" id="ftcmO3">' +
          '<div class="ftcm-option" data-t="15" data-d="20" data-r="5" data-f="15"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Kaklas ir pe\u010diai</div></div>' +
          '<div class="ftcm-option" data-t="10" data-d="25" data-r="10" data-f="10"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Nugara (juosmuo, kr\u016btin\u0117)</div></div>' +
          '<div class="ftcm-option" data-t="25" data-d="10" data-r="5" data-f="15"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Visas k\u016bnas</div></div>' +
          '<div class="ftcm-option" data-t="5" data-d="5" data-r="30" data-f="15"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Konkretus sąnarys ar sritis po traumos</div></div>' +
        '</div>' +
      '</div>' +

      // Q4 — Activity level
      '<div class="ftcm-slide" id="ftcmQ4">' +
        '<div class="ftcm-question-num">4 klausimas i\u0161 5</div>' +
        '<div class="ftcm-question-text">Koks jūsų fizinio aktyvumo lygis?</div>' +
        '<div class="ftcm-question-hint">Aktyvumo lygis padeda nustatyti optimalią masa\u017eo intensyvumą.</div>' +
        '<div class="ftcm-options" id="ftcmO4">' +
          '<div class="ftcm-option" data-t="15" data-d="15" data-r="5" data-f="20"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">S\u0117dimas darbas, ma\u017eai jud\u0117jimo</div></div>' +
          '<div class="ftcm-option" data-t="20" data-d="15" data-r="5" data-f="15"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Vidutinis aktyvumas (pasivaikščiojimai, joga)</div></div>' +
          '<div class="ftcm-option" data-t="5" data-d="25" data-r="15" data-f="10"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Intensyvus sportas ar fizinis darbas</div></div>' +
          '<div class="ftcm-option" data-t="5" data-d="5" data-r="35" data-f="10"><div class="ftcm-option-radio"></div><div class="ftcm-option-text">Atsigaunu po traumos ar operacijos</div></div>' +
        '</div>' +
      '</div>' +

      // Q5 — Pain intensity slider
      '<div class="ftcm-slide" id="ftcmQ5">' +
        '<div class="ftcm-question-num">5 klausimas i\u0161 5</div>' +
        '<div class="ftcm-question-text">Koks yra jūsų skausmo ar diskomforto stiprumas?</div>' +
        '<div class="ftcm-question-hint">Įvertinkite vidutinį diskomforto lygį per pastarąją savaitę.</div>' +
        '<div class="ftcm-slider-wrap"><div class="ftcm-slider-labels"><span class="ftcm-slider-label left">Silpnas, pakenčiamas</span><span class="ftcm-slider-label right">Stiprus, nuolatinis</span></div>' +
        '<div class="ftcm-range-track"><input type="range" class="ftcm-range" id="ftcmR5" min="0" max="100" value="50"></div>' +
        '<div class="ftcm-range-value" id="ftcmV5"></div></div>' +
      '</div>' +

      // Email gate
      '<div class="ftcm-slide" id="ftcmEmail"><div class="ftcm-email-gate">' +
        '<div class="ftcm-email-icon">' + svgMail + '</div>' +
        '<h3>Jūsų rekomendacija paruošta!</h3>' +
        '<p>Įveskite savo el. paštą ir gaukite detalią masa\u017eo rekomendaciją bei patarimų paketą.</p>' +
        '<div class="ftcm-input-wrap"><input type="email" class="ftcm-input" id="ftcmEmailInput" placeholder="j\u016bsų@elpa\u0161tas.lt"><div class="ftcm-email-error" id="ftcmEmailError">Įveskite teisingą el. pašto adresą</div></div>' +
        '<button class="ftcm-btn ftcm-btn-primary ftcm-btn-large" id="ftcmEmailBtn">Gauti rekomendaciją ' + svgCheck + '</button>' +
        '<div class="ftcm-email-note">Gal\u0117site bet kada atsisakyti naujienlaiškio.</div>' +
      '</div></div>' +

      // Results
      '<div class="ftcm-slide" id="ftcmResults"><div class="ftcm-results">' +
        '<div class="ftcm-result-circle-wrap"><div class="ftcm-result-circle" id="ftcmResultCircle"><div class="ftcm-result-type" id="ftcmResultType"></div><div class="ftcm-result-label" id="ftcmResultLabel"></div></div></div>' +
        '<div class="ftcm-result-text" id="ftcmResultText"></div>' +
        '<div class="ftcm-result-detail" id="ftcmResultDetail"><h4 id="ftcmDetailTitle"></h4><p id="ftcmDetailText"></p></div>' +
        '<a class="ftcm-result-cta" href="' + BOOKING_URL + '" target="_blank">Registruotis masa\u017eui ' + svgCalendar + '</a>' +
        '<div class="ftcm-disclaimer">\u0160is klausimynas yra informacinio pob\u016bd\u017eio. Galutinę masa\u017eo techniką parinks specialistas konsultacijos metu.</div>' +
      '</div></div>' +

      // Nav
      '<div class="ftcm-buttons" id="ftcmNav" style="display:none;">' +
        '<button class="ftcm-btn ftcm-btn-secondary" id="ftcmBtnBack">' + svgArrowLeft + ' Atgal</button>' +
        '<button class="ftcm-btn ftcm-btn-primary" id="ftcmBtnNext">Kitas ' + svgArrowRight + '</button>' +
      '</div>' +

    '</div>';

  // ── Mount ──
  var target = document.getElementById('ftc-massage-checker');
  if (!target) return;
  var root = document.createElement('div');
  root.className = 'ftcm';
  root.id = 'ftcmChecker';
  root.innerHTML = html;
  target.appendChild(root);

  // ── State ──
  var currentStep = 0;
  var totalSteps = 5;
  var scores = { t: 0, d: 0, r: 0, f: 0 }; // therapeutic, deeptissue, rehab, myofascial
  var selectedOpts = {};
  var sliderVal = 50;

  var nav          = document.getElementById('ftcmNav');
  var progressWrap = document.getElementById('ftcmProgressWrap');
  var backBtn      = document.getElementById('ftcmBtnBack');
  var nextBtn      = document.getElementById('ftcmBtnNext');
  var progressFill = document.getElementById('ftcmProgressFill');
  var stepCount    = document.getElementById('ftcmStepCount');

  // ── Event listeners ──
  document.getElementById('ftcmStartBtn').addEventListener('click', function () {
    currentStep = 1; showStep();
  });
  nextBtn.addEventListener('click', function () {
    // Only used for step 5 (slider) → go to email gate
    currentStep = 6;
    showStep();
  });
  backBtn.addEventListener('click', function () {
    currentStep = currentStep === 6 ? totalSteps : Math.max(1, currentStep - 1);
    showStep();
  });
  document.getElementById('ftcmEmailBtn').addEventListener('click', submitEmail);

  // Slider Q5
  document.getElementById('ftcmR5').addEventListener('input', function () { updateSlider(); });

  // Option cards Q1-Q4 (auto-advance)
  [1, 2, 3, 4].forEach(function (q) {
    document.querySelectorAll('#ftcmO' + q + ' .ftcm-option').forEach(function (el) {
      el.addEventListener('click', function () {
        if (selectedOpts[q]) {
          scores.t -= parseInt(selectedOpts[q].getAttribute('data-t'));
          scores.d -= parseInt(selectedOpts[q].getAttribute('data-d'));
          scores.r -= parseInt(selectedOpts[q].getAttribute('data-r'));
          scores.f -= parseInt(selectedOpts[q].getAttribute('data-f'));
        }
        scores.t += parseInt(el.getAttribute('data-t'));
        scores.d += parseInt(el.getAttribute('data-d'));
        scores.r += parseInt(el.getAttribute('data-r'));
        scores.f += parseInt(el.getAttribute('data-f'));
        selectedOpts[q] = el;
        el.parentElement.querySelectorAll('.ftcm-option').forEach(function (s) { s.classList.remove('selected'); });
        el.classList.add('selected');
        // Auto-advance after brief visual feedback
        setTimeout(function () {
          currentStep = q + 1;
          showStep();
        }, 350);
      });
    });
  });

  // ── Functions ──
  function updateSlider() {
    sliderVal = parseInt(document.getElementById('ftcmR5').value);
    var valEl = document.getElementById('ftcmV5');
    if (sliderVal < 20) valEl.textContent = 'Minimalus diskomfortas';
    else if (sliderVal < 40) valEl.textContent = 'Lengvas skausmas';
    else if (sliderVal < 60) valEl.textContent = 'Vidutinis skausmas';
    else if (sliderVal < 80) valEl.textContent = 'Stiprus skausmas';
    else valEl.textContent = 'Labai stiprus skausmas';
  }

  function getResult() {
    // Slider influence: high pain → boost deep tissue and rehab
    var ft = scores.t + Math.round((100 - sliderVal) * 0.2);
    var fd = scores.d + Math.round(sliderVal * 0.3);
    var fr = scores.r + Math.round(sliderVal * 0.15);
    var ff = scores.f + Math.round(sliderVal * 0.1);
    if (ft >= fd && ft >= fr && ft >= ff) return 'therapeutic';
    if (fd >= ft && fd >= fr && fd >= ff) return 'deeptissue';
    if (fr >= ft && fr >= fd && fr >= ff) return 'rehab';
    return 'myofascial';
  }

  function submitEmail() {
    var emailInput = document.getElementById('ftcmEmailInput');
    var email = emailInput.value.trim();
    var errorEl = document.getElementById('ftcmEmailError');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.style.display = 'block'; emailInput.style.borderColor = '#e05555'; return;
    }
    errorEl.style.display = 'none'; emailInput.style.borderColor = '#00BEC3';
    sendToKlaviyo(email);
    currentStep = 7; showStep(); computeResults();
  }

  function sendToKlaviyo(email) {
    if (!KLAVIYO_COMPANY_ID || !KLAVIYO_LIST_ID) return;
    var resultType = getResult();
    var subData = {
      data: { type: 'subscription', attributes: { custom_source: 'Massage Type Widget',
        profile: { data: { type: 'profile', attributes: { email: email },
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } } }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(subData)
    }).then(function (r) { console.log('[FTC Massage] subscribe:', r.status); }).catch(function (e) { console.error('[FTC Massage]', e); });
// Also subscribe to combined widget list
subData.data.relationships.list.data.id = 'VfJCJm';
fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},body:JSON.stringify(subData)}).then(function(r){console.log('[FTC] combined:',r.status);}).catch(function(e){console.error(e);});
subData.data.relationships.list.data.id = KLAVIYO_LIST_ID;
resultType = {therapeutic:'Terapinis masažas',deeptissue:'Giliųjų audinių masažas',rehab:'Reabilitacinis masažas',myofascial:'Miofascialinis atpalaidavimas'}[resultType] || resultType;
    var profileData = {
      data: { type: 'profile', attributes: { email: email, properties: {
        massage_type_result: resultType,
        massage_type_date: new Date().toISOString()
      } } }
    };
    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(profileData)
    }).then(function (r) { console.log('[FTC Massage] profile:', r.status); }).catch(function (e) { console.error('[FTC Massage]', e); });
  }

  function computeResults() {
    var result = getResult();
    var circle = document.getElementById('ftcmResultCircle');
    var typeEl = document.getElementById('ftcmResultType');
    var labelEl = document.getElementById('ftcmResultLabel');
    var textEl = document.getElementById('ftcmResultText');
    var dTitle = document.getElementById('ftcmDetailTitle');
    var dText = document.getElementById('ftcmDetailText');
    circle.className = 'ftcm-result-circle';

    if (result === 'therapeutic') {
      circle.classList.add('therapeutic');
      typeEl.textContent = 'Rekomenduojama';
      labelEl.textContent = 'Terapinis masa\u017eas';
      textEl.textContent = 'Jūsų atsakymai rodo, kad geriausiai tiktų terapinis (gydomasis) masa\u017eas — universalus metodas, apjungiantis atpalaidavimą su tiksliniu skausmo mal\u0161inimu.';
      dTitle.textContent = 'Kas yra terapinis masa\u017eas?';
      dText.textContent = 'Terapinis masa\u017eas apjungia klasikines ir modernias technikas: \u0161vedišką masa\u017eą, minkštųjų audinių mobilizaciją ir trigerinių taškų terapiją. Jis padeda sumažinti raumenų įtampą, pagerinti kraujotaką ir bendrą savijautą. Idealus pasirinkimas bendram diskomfortui, stresui ir raumenų nuovargiui mal\u0161inti.';
    } else if (result === 'deeptissue') {
      circle.classList.add('deeptissue');
      typeEl.textContent = 'Rekomenduojama';
      labelEl.textContent = 'Giliųjų audinių masa\u017eas';
      textEl.textContent = 'Jūsų simptomai rodo, kad geriausiai tiktų giliųjų audinių masa\u017eas — intensyvi technika, skirta giluminei raumenų įtampai ir l\u0117tiniams skausmams mal\u0161inti.';
      dTitle.textContent = 'Kas yra giliųjų audinių masa\u017eas?';
      dText.textContent = 'Giliųjų audinių masa\u017eas taiko intensyvų spaudimą giliesniams raumenų sluoksniams, fascijoms ir jungiamiesiems audiniams. Ypač efektyvus l\u0117tiniams \u201emazgams\u201c, nugaros ir kaklo skausmams, sporto traumų prevencijai. Procedūra gali būti intensyvesn\u0117, ta\u010diau rezultatai jaučiami greitai.';
    } else if (result === 'rehab') {
      circle.classList.add('rehab');
      typeEl.textContent = 'Rekomenduojama';
      labelEl.textContent = 'Reabilitacinis masa\u017eas';
      textEl.textContent = 'Jūsų atsakymai rodo, kad geriausiai tiktų reabilitacinis masa\u017eas — specializuota technika, skirta atsigavimui po traumų, operacijų ar ilgalaikio nejudumo.';
      dTitle.textContent = 'Kas yra reabilitacinis masa\u017eas?';
      dText.textContent = 'Reabilitacinis masa\u017eas yra suplanuota terapin\u0117 programa, apjungianti minkštųjų audinių mobilizaciją, judesių amplitudes didinimą ir skausmo kontrolę. Jis padeda atkurti raumenų funkciją, suma\u017einti randinio audinio formavimąsi ir paspartinti gijimą. Specialistas pritaikys intensyvumą pagal jūsų gijimo stadiją.';
    } else {
      circle.classList.add('myofascial');
      typeEl.textContent = 'Rekomenduojama';
      labelEl.textContent = 'Miofascialinis atpalaidavimas';
      textEl.textContent = 'Jūsų atsakymai rodo, kad geriausiai tiktų miofascialinis atpalaidavimas — specializuota technika, veikianti fascijų (jungiamojo audinio) tinklą ir gerinanti judrumą.';
      dTitle.textContent = 'Kas yra miofascialinis atpalaidavimas?';
      dText.textContent = 'Fascijos — tai jungiamieji audiniai, apgaubiantys visus raumenis, kaulus ir organus. Kai fascijos \u201esukietėja\u201c, ribojamas judrumas ir atsiranda skausmas. Miofascialinis atpalaidavimas taiko l\u0117tą, nuoseklų spaudimą, kuris atlaisvina fascijų suau\u0117jimus ir atkuria kūno judrumą. Ypač efektyvus sustingimui, ribotam judėjimui ir l\u0117tiniam diskomfortui.';
    }
  }

  function showStep() {
    var slides = document.querySelectorAll('#ftcmChecker .ftcm-slide');
    slides.forEach(function (s) { s.classList.remove('active'); });

    if (currentStep === 0) {
      document.getElementById('ftcmIntro').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    } else if (currentStep >= 1 && currentStep <= totalSteps) {
      document.getElementById('ftcmQ' + currentStep).classList.add('active');
      progressWrap.style.display = 'block';
      progressFill.style.width = Math.round((currentStep / totalSteps) * 100) + '%';
      stepCount.textContent = currentStep + ' i\u0161 ' + totalSteps + ' klausimų';
      // Steps 1-4: auto-advance on click, hide Next; Step 5 (slider): show Next
      if (currentStep <= 4) {
        nav.style.display = currentStep === 1 ? 'none' : 'flex';
        nextBtn.style.display = 'none';
        backBtn.style.visibility = 'visible';
      } else {
        nav.style.display = 'flex';
        nextBtn.style.display = '';
        backBtn.style.visibility = 'visible';
        nextBtn.innerHTML = 'Gauti rekomendaciją ' + svgCheck;
        updateSlider();
      }
    } else if (currentStep === 6) {
      document.getElementById('ftcmEmail').classList.add('active');
      nav.style.display = 'flex'; progressWrap.style.display = 'block';
      progressFill.style.width = '100%';
      stepCount.textContent = 'Paskutinis \u017eingsnis';
      backBtn.style.visibility = 'visible'; nextBtn.style.display = 'none';
    } else if (currentStep === 7) {
      document.getElementById('ftcmResults').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    }
  }

})();